export const SET_MENUS = "SET_MENUS";
export const SET_LOADING_MENUS = "SET_LOADING_MENUS";
export const INTRODUCTION_TOUR = "INTRODUCTION_TOUR";
export const SUBSCRIPTION_STATUS = "SUBSCRIPTION_STATUS";
export const SITE_LOADING = "SITE_LOADING";
